import { connect } from 'react-redux';
import SelectSearch from '../../components/Inputs/SelectSearch';

const mapStateToProps = (state, props) => {
  const [store, ...storeKey] = props.storeKey.split('.');
  storeKey.push('value');
  return ({
    value: state[store].getIn(storeKey),
  });
};

export default connect(mapStateToProps)(SelectSearch);
